import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import "./NotFound.scss";

const NotFound = () => {
    const history = useHistory();

    return (
        <div className="not-found-page">
            <div className="not-found-content">
                <h1 className="not-found-code">404</h1>
                <h2 className="not-found-title">Page Not Found</h2>
                <p className="not-found-description">
                    The page you are looking for does not exist or has been moved.
                </p>
                <div className="not-found-actions">
                    <Button
                        className="primary-gradient-btn rounded-pill px-4"
                        onClick={() => history.push("/home")}
                    >
                        Go to Dashboard
                    </Button>
                   
                </div>
            </div>
        </div>
    );
};

export default NotFound;
